import { filterPolicySectionTree, type PolicySectionTreeNode } from "./policySectionTree";

export type PolicyPortfolioBranch<PolicyId extends string, SectionId extends string> = {
  readonly policyId: PolicyId;
  readonly title: string;
  readonly sections: readonly PolicySectionTreeNode<SectionId>[];
};

export const portfolioPolicySelection = <PolicyId extends string>({
  orderedIds,
  routeId,
  requestedId,
  currentId,
}: {
  readonly orderedIds: readonly PolicyId[];
  readonly routeId: PolicyId | undefined;
  readonly requestedId: PolicyId | null;
  readonly currentId: PolicyId | null;
}): PolicyId | null => {
  const known = new Set(orderedIds);
  if (routeId !== undefined && known.has(routeId)) return routeId;
  if (requestedId !== null && known.has(requestedId)) return requestedId;
  if (currentId !== null && known.has(currentId)) return currentId;
  return orderedIds[0] ?? null;
};

export const filterPolicyPortfolio = <
  PolicyId extends string,
  SectionId extends string,
  Branch extends PolicyPortfolioBranch<PolicyId, SectionId>,
>(
  branches: readonly Branch[],
  query: string,
): readonly Branch[] => {
  const needle = query.trim().toLocaleLowerCase();
  if (needle === "") return branches;
  return branches.flatMap((branch) => {
    const policyMatches = branch.title.toLocaleLowerCase().includes(needle);
    const sections = policyMatches ? branch.sections : filterPolicySectionTree(branch.sections, needle);
    return policyMatches || sections.length > 0 ? [{ ...branch, sections } as Branch] : [];
  });
};
